<template>
    <el-dialog v-loading="loading.dialog" class="uatTesting_model_dialog" top="20vh" center
      title='环境部署' width="50%" :append-to-body="true"
      :before-close="handleClose" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <el-form ref="form" size="mini" :rules="rules" :model="form">
        <div style="display: flex;">
          <el-form-item label="主域名" prop="domain" :label-width="formLabelWidth">
            <el-select style="width: 100%" @change="onChangeSelect('domain')"
                    v-model="form.domain" placeholder="请选择主域名">
          <el-option v-for="(item, index) in domains" :key="index" :label="item[0] + ' （' + item[1] + '）'"
                     :value="item[1]"></el-option> 
        </el-select>
        </el-form-item>
          <el-form-item label="系统" label-width="65px">
            <el-select style="width: 100%" filterable collapse-tags v-model="form.module" :placeholder="'请选择模块名'"
                   @change="onChangeSelect('module')" >
          <el-option v-for="(item, index) in modules" :key="index" :label="item[0]" :value="item[1]"></el-option>
        </el-select>
        </el-form-item>
        </div>
        <el-form-item label="部署环境" prop="env" :label-width="formLabelWidth">
          <el-select style="width: 35%" v-model="form.env" placeholder="请选择环境" @change="onChangeSelect('env')" filterable>
            <el-option v-for="(item, index) in ENVS" :key="index" :label="item[0]" :value="item[1]"></el-option>
          </el-select>
          <el-popover @show="queryDeployCenterList()" placement="bottom" width="900" trigger="click">
            <el-table :cell-style="getRowClass" max-height="400" v-loading="loading.envFootprint" :data="deploy_info">
              <el-table-column fixed width="150" property="moduleEnv" label="模块环境" />
              <el-table-column property="name" label="姓名" min-width="120" />
              <el-table-column property="branch" label="分支" />
              <el-table-column property="startDate" label="开始时间" min-width="100" sortable />
              <el-table-column property="holeUpTime" min-width="100" label="占用时间" sortable />
              <el-table-column property="commit" label="commit" />
              <el-table-column fixed="right" width="220" align="center" label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" :type="releaseType(scope.row.holeUpTime).type" plain
                    v-if="scope.row.platform === 'walle'" @click="handleRelease(scope.$index, scope.row)">发布({{
                      scope.row.platform
                    }})
                  </el-button>
                  <span v-else
                    :style="`color: ${releaseType(scope.row.holeUpTime).color};width: 91.4px;display: inline-block;text-align: center;margin-right: 10px;`">{{
                      scope.row.platform.toLocaleUpperCase()
                    }}
                  </span>
                  <el-button size="mini"
                    v-if="scope.row.platform !== 'docker' || releaseType(scope.row.holeUpTime).type === 'success'"
                    type="primary" plain @click="handleRorrelation(scope.$index, scope.row)">查看配置
                  </el-button>
                  <div style="display: flex" v-else>
                    <el-button size="mini" type="primary" plain @click="handleRorrelation(scope.$index, scope.row)">查看配置
                    </el-button>
                    <el-button size="mini" type="warning" style="margin-top: 4px;" plain
                      @click="handleReleaseOccupy(scope.$index, scope.row)">解除占用
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <span slot="reference" style="margin-left: 20px; color: #67c23a; cursor: pointer">查看环境占用情况</span>
          </el-popover>
          <span style="margin-left: 20px; color: #e6a23c" v-if="intelligentEnv">{{
            intelligentEnv
          }}</span>
        </el-form-item>
      
        <el-form-item label="代码分支" prop="branch" :label-width="formLabelWidth">
          <el-select style="width: 100%" v-model="form.branch" filterable remote reserve-keyword
                   @change="onChangeSelect('branch')" placeholder="请选择分支" >
          <el-option v-for="item in branchOptions" :key="item.label" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="版本" prop="commit" :label-width="formLabelWidth">
          <div style="display: flex">
            <el-select style="width: 90%;margin-right: 10px" v-model="form.commit" filterable placeholder="请选择版本"
                      >
              <el-option v-for="item in commitOptions" :key="item.label" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-button :loading="loading.commit" type="primary"
              @click="queryDevOpsSpaceStageSelectmapApi(form.module, 'refresh')">刷新</el-button>
          </div>
        </el-form-item>
        <el-form-item label="占用期限" prop="due_time" :label-width="formLabelWidth">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" v-model="form.due_time" type="datetime"
            default-time="23:59:59" placeholder="默认占用至当天结束" />
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-button :loading="loading.uatEnvRelease" type="warning" @click="checkEnvReleaseOccupation">环境发布
          </el-button>
          <el-button type="primary" @click="queryActionNowLogInfo('env')">实时日志</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="handleClose">关 闭</el-button>
      </div>
  
      <!--  #region dialogVisible 部分 -->
      <el-dialog :close-on-click-modal="false" custom-class="uatTesting_model_dialog_child" width="80%" center
        :title="showId + '额外部署SQL文件'" :visible.sync="dialog.sqlVisible" append-to-body>
        <Codemirror v-if="dialog.sqlVisible" style="margin-bottom: 10px" sqlStyle="height:200px;" ref="sqlFileditor"
          :value="form.sqlExtracontent" @changeTextarea="changeTextarea($event, 'sqlExtracontent')" />
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleSqlDialogVisible('save')">保存</el-button>
          <span style="font-size: 15px;color: #666;font-weight: bold;margin-left: 10px;position: absolute;bottom: 30px;"
            v-if="sqlQualityTestInfo.score < 100">
            分数:<span :style="{ color: sqlQualityTestInfo.score > 90 ? '#67C23A' : '#E6A23C' }">{{ sqlQualityTestInfo.score
            }}</span><a style="color: rgb(64, 158, 255);margin-left: 20px;" :href="sqlQualityTestInfo.origin_url"
              target="_blank" v-if="sqlQualityTestInfo.origin_url">查看报告</a>
          </span>
        </div>
      </el-dialog>
  
      <el-dialog :close-on-click-modal="false" custom-class="uatTesting_model_dialog_child" width="80%" center
        :title="showId + '执行SQL'" v-if="dialog.sqlDoneVisible" :visible.sync="dialog.sqlDoneVisible" append-to-body>
        <Progress :progressInfo="progressBar" />
        <pre ref="webSocket" v-html="webSocket.msg" class="tips-message websocket_style" />
        <WebSocket v-if="webSocket.url" />
      </el-dialog>
  
      <el-dialog :close-on-click-modal="false" custom-class="uatTesting_model_dialog_child" width="80%" center
        :title="showId + 'SQL执行历史记录'" :visible.sync="dialog.sqlLogVisible" append-to-body>
        <TableFive :moduleType="form.module" :tableData="tableData.sqlList" />
      </el-dialog>
  
      <el-dialog :close-on-click-modal="false" custom-class="uatTesting_model_dialog_child" width="80%" center
        :title="showId + '环境代码发布'" v-if="dialog.releaseResultVisible" :visible.sync="dialog.releaseResultVisible"
        append-to-body>
        <Progress :progressInfo="progressBar" />
        <pre ref="webSocket" class="tips-message websocket_style" v-html="webSocket.msg" />
        <WebSocket v-if="webSocket.url" />
      </el-dialog>
  
      <el-dialog :close-on-click-modal="false" custom-class="preEnvTesting_model_dialog_child" width="80%" center
        :title="showId + '发布记录'" :visible.sync="dialog.releaseLogVisible" append-to-body>
        <TableOne :tableData="tableData.releaseList" />
      </el-dialog>
  
      <el-dialog :close-on-click-modal="false" custom-class="uatTesting_model_dialog_child" center :title="showId + '关联配置'"
        :visible.sync="dialog.rorrelationVisible" width="80%" append-to-body left>
        <pre
          style="white-space: pre-line;height: 300px;overflow-y: auto;background-color: #efefef;">{{ msg.rorrelationContentMsg }}</pre>
      </el-dialog>
  
      <el-dialog title="提示" :visible.sync="dialog.releaseTipVisible" width="60%" center append-to-body>
        <div style="text-align:center;">该环境（{{
          ENVS[current_deploy_info.env]
        }}）已被占用至（{{ current_deploy_info.time }}），请与{{ allSelect.TEXTUSERS[current_deploy_info.name] }}（{{
    current_deploy_info.name
  }}）联系，确认后再点击继续发布
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialog.releaseTipVisible = false">取 消</el-button>
          <el-button type="warning" @click="queryUatEnvRelease">继续发布</el-button>
        </span>
      </el-dialog>
  
      <el-dialog title="提示" :visible.sync="dialog.gobackdev" width="30%" center append-to-body>
        <div style="text-align:center;">是否确认回退？</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialog.gobackdev = false">取 消</el-button>
          <el-button type="warning" :loading="loading.gobackdev" @click="submit('gobackdev')">继续回退</el-button>
        </span>
      </el-dialog>
  
      <el-dialog :close-on-click-modal="false" custom-class="preEnvTesting_model_dialog_child" width="80%" center
        :title="showId + '实时日志'" v-if="dialog.releaseResultLogVisible" :visible.sync="dialog.releaseResultLogVisible"
        append-to-body>
        <pre ref="webSocket" class="tips-message websocket_style" v-html="webSocket.msg" />
        <WebSocket v-if="webSocket.url" />
      </el-dialog>
  
      <el-dialog :close-on-click-modal="false" custom-class="developing_model_dialog_child" width="40%" center
        :title="showId + 'SQL质量检测'" :visible.sync="dialog.sqlQualityTest" append-to-body>
        <div
          style="display: flex;padding: 10px 20px;font-size: 15px;color: #666;justify-content: space-around;font-weight: bold">
          <div :style="{ color: sqlQualityTestInfo.score > 90 ? '#67C23A' : '#E6A23C' }"><span
              style="color: #666;">分数：</span>{{ sqlQualityTestInfo.score }}</div>
          <a style="color: rgb(64, 158, 255);" :href="sqlQualityTestInfo.origin_url" target="_blank"
            v-if="sqlQualityTestInfo.origin_url">查看报告</a>
        </div>
      </el-dialog>
      <!--  #endregion -->
    </el-dialog>
  </template>
  <script>
  import {
    postODUDADcreateApi,
    getDevOpsSpaceListStageParmApi,
    postDevopsSpaceStageActionNewApi,
    postDeployCenterApi,
    getAutoCustomerApi,
    getEdiApi,
    postUpdateEdiApi,
    getDevOpsSpaceListStageOutputApi,
    postDeployRecordingApi,
    getDevOpsSpaceTaskDetailApi,
    getDevOpsSpaceFindOneDemandApi,
    getDevOpsSpaceStageSelectmapApi,
  } from "@/server/tops/devOps";
  import {
    TableFive,
    TableOne,
    TableThir,
  } from "@/views/tops/devOps/components/table/index.js";
  import {
    formatDate,
  } from "@/views/tops/devOps/components/util.js";
  import { Codemirror, Progress, Editor, WebSocket } from "@/components";
  import { mapState, mapMutations } from "vuex";
  import { formatStrToArr } from '../../components/util';
  export default {
    components: { Codemirror, TableFive, Progress, TableOne, TableThir, Editor, WebSocket },
    props: {
      formInfo: {
        type: Object,
        default: function () {
          return {};
        },
      },
      dialogVisible: {
        type: Boolean,
        default: function () {
          return false;
        },
      },
      hideDialogVisible: {
        type: Function,
        default: function () {
          return () => { };
        },
      },
    },
    data() {
      return {
        branchOptions:[],
        domains:[],
        modules:[],
        is_allow_skip:'false',
        form: {
          commit:'',
          module:'',
          env: "",
          uat_content: '',
          sqlExtracontent: '',
          sqlcontent: '',
          domain: '',
        },
        rules: {
          env: {
            required: true,
            message: "必填",
            trigger: "blur",
          },
        },
        formLabelWidth: "140px",
        ENVS: {},
        BRANCHS: {},
        TEXTCOMMITS: {}, // 版本列表
        dialog: {
          sqlLogVisible: false,
          rorrelationVisible: false,
          sqlVisible: false,
          uatEnvSqlDone: false,
          sqlDoneVisible: false,
          releaseResultVisible: false,
          releaseLogVisible: false,
          releaseTipVisible: false,
          gobackdev: false,
          releaseResultLogVisible: false,
          sqleditor: true,
          sqlQualityTest: false
        },
        loading: {
          uatTestinged: false,
          envFootprint: false,
          skip: false,
          dialog: true,
          gobackdev: false,
          uatEnvSqlDone: false,
          uatEnvRelease: false,
          sqlQualityTest: false
        },
        tableData: {
          sqlList: [],
          releaseList: []
        },
        msg: {
          rorrelationContentMsg: "",
        },
        // #region 环境部分
        deploy_info: [],
        current_deploy_info: {},
        intelligentEnv: '',
        // #endregion
        showId: '',
        sqlQualityTestInfo: {},
        cacheModules:[]
      };
    },
    async created() {
    //     console.log('dialogVisible', this.dialogVisible);
    //   const {
    //     id,
    //     module = '' ,
    //     taskName = "",
    //   } = this.formInfo;
    //   this.showId = `【${id}】`
    //   this.form = { ...this.form, id, module, taskName };
    //   if(id) await this.queryDevOpsSpaceTaskDetail();
    //   await this.queryDevOpsSpaceListStageParmInfo();
    //   this.queryDevOpsSpaceStageSelectmapApi(module);
    //   if(this.form.demandId) await this.getDemandetail(this.form.demandId);
       await this.getSelectInit()
    },
    computed: {
      ...mapState({
        progressBar: (state) => state.devOps.PROGRESSSBAR,
        allSelect: (state) => state.devOps.ALLSELECT,
        webSocket: (state) => state.devOps.WEBSOCKET
      }),
      techReviewerCh() {
        let names = '';
        this.form.tech_reviewer.split(",").forEach((item) => {
          if (this.allSelect.TEXTUSERS[item]) {
            names += this.allSelect.TEXTUSERS[item] + ' '
          }
        })
        return names;
      },
      showGitDeploy() {
        const { module = '', domain = '' } = this.form;
        const newOrigin = `${module}.${domain}`;
        const origins = ['odoo.ehsy.com', 'mall.raxwell.cn']
        return origins.includes(newOrigin);
      }
    },
    updated() {
      this.scrollToBottom({ bind: this, refName: 'webSocket' })
    },
    methods: {
     async onChangeSelect(type){
      if(type === 'domain'||type === 'module'){
            this.ENVS=[]
          }
      if (type === 'domain') { // 选择主域名时，系统参数跟着变更
        this.modules = this.cacheModules.filter(item => {
          return item[2] === this.form.domain
        });
        this.form.module = this.modules[0][1] || '';
      }
        try {
         
          
          const ret = await postODUDADcreateApi({
            stage_env: 'uat',
            module_name: this.form.module || "",
            branch: this.form.branch,
            domain: this.form.domain,
          });
          this.ENVS= ret['envs'].filter(item=>item[0]!=='智能选择'&&item[0]!=='prod'&&item[0]!=='prod')
          this.branchOptions=[]
          ret['branchs'].forEach(item=>{
            console.log('item', item);
            this.branchOptions.push({
              label:item,
              value:item.split(" ")[0]
            })
          })
          if(type!=='branch'){
            // this.form.branch = ret?.branchs ? ret.branchs[0].split(' ')[0] : "";
          }
          
          if(type!=='env'){
            // this.form.env=this.ENVS[0][1]
          }
          if (type === "branch" || type === 'domain') {
          this.commits = this.commitOptions =
              ret?.commits?.map((item) => {
                return { value: `${item.split(" ")[0]}`, label: `${item}` };
              }) || [];
          // this.form.commit = ret?.commits ? ret.commits[0].split(' ')[0] : "";
        }
          console.log('ret', ret);
          // console.log('this.ENVS', this.ENVS);
        } catch (error) {
          
        }
      },
    async  getSelectInit(){
        const res = await getDevOpsSpaceStageSelectmapApi();
        this.domains = res["operator_prodCodeDeploy-domain"];
        this.cacheModules = res["devops-tasklist-module"];
        this.modules = res["devops-tasklist-module"].filter(item => item[2] === this.form.domain);
      },
      ...mapMutations(['setProgressBar', 'openWebSocket', 'sendWebSocket', 'closeWebSocket', 'scrollToBottom']),
      // 环境占用情况样式
      getRowClass({ row, column, rowIndex, columnIndex }) {
        // console.log(row, column, rowIndex, columnIndex)
        if (columnIndex === 4) {
          return `color:${this.releaseType(row.holeUpTime).color};`
        }
      },
      // 获取任务详情
      async queryDevOpsSpaceTaskDetail() {
        this.loading.dialog = true;
        try {
          const ret = await getDevOpsSpaceTaskDetailApi({
            taskId: this.formInfo.id || "",
            space: 'producerSpace',
          });
          const info = ret.data[0] || {};
          this.form = {
            ...this.form,
            ...info,
          };
        } catch (error) {
          this.$notify({
            message: error || "获取任务详情失败",
            type: "error",
          })
        } finally {
          this.loading.dialog = false;
        }
      },
      // 获取需求详情
      async getDemandetail(id) {
        this.loading.dialog = true
        try {
          const ret = await getDevOpsSpaceFindOneDemandApi({id:id });
          const info = ret.data[0] || {};
          this.form = {
            ...this.form,
            pm:info.pm,
          };
          if (info.details) { this.showDetails = true };
        } catch (error) {
          this.$notify({
            message: error || "数据错误",
            type: "error",
          })
        } finally {
          this.loading.dialog = false
        }
      },
      // 获取select
      async queryDevOpsSpaceStageSelectmapApi(module, type) {
        try {
          const ret = await postODUDADcreateApi({
            module_name: module || "BACKEND",
            branch: this.form.branch || "",
            stage_env: 'uat',
            domain: this.form.domain
          });
          this["TEXTCOMMITS"] = ret?.commits?.map((v) => {
            return [v.split(" ")[0], v];
          });
          this.form.commit = ret.commits[0]?.split(" ")[0] || "";
          if (type === "refresh") return;
          let envs = {};
          ret.envs.forEach((item) => {
            if (item[1] === 'intelligent') return;
            return (envs[item[1]] = item[0]);
          });;
          this["ENVS"] = envs;
          this.form.env = Object.keys(envs)[0] || ''
          if (!Object.keys(envs).length) return (this.intelligentEnv = "此系统暂时无环境，请直接跳过")
          let branchs = {}
          ret.branchs.map((item) => { branchs[item] = item; });
          this['BRANCHS'] = branchs;
        } catch (error) {
          this.$notify({
            message: error || "获取select失败",
            type: "error",
          });
        } finally {
          this.loading.dialog = false
        }
      },
      // 获取开发中任务阶段设置信息
      async queryDevOpsSpaceListStageParmInfo() {
        try {
          const { id = "", demandId = "" } = this.form;
          const ret = await getDevOpsSpaceListStageParmApi({
            stage_id: 0,
            task_id: 0,
            pid: 0,
          });
          const loginusername = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
          if(ret.data.is_admin === 1  || this.form.user_pm === loginusername){
            this.is_allow_skip = 'true';
          }
          if (ret.status === "success") {
            const { common_branch: branch, env = '', due_time = '' } = ret.data || {};
            this.form = {
              ...this.form,
              branch,
              env,
              due_time,
            };
          } else {
            this.$notify({
              message: ret.error || "数据错误",
              type: "error",
            });
          }
        } catch (error) {
          this.$notify({
            message: error || "数据错误",
            type: "error",
          });
        } finally {
          this.loading.dialog = false
        }
      },
      // 关闭弹窗
      handleClose(step) {
        this.hideDialogVisible(step);
      },
      // 获取预发环境历史执行信息
      async queryPreEnvReleaseLog() {
        const { demandId = "", id = "" } = this.form;
        try {
          const ret = await getDevOpsSpaceListStageOutputApi({
            stage_id: 0,
            task_id: 0,
            pid: 0,
          });
          if (ret.status === "success") {
            let instance = JSON.parse(ret.data) || [];
            instance.map((item) => {
              return (item.content = JSON.stringify(item.output, null, 2));
            });
            console.log(instance)
            this.tableData.releaseList = instance;
            this.dialog.releaseLogVisible = true;
          } else {
            this.tableData.releaseList = [];
          }
        } catch (error) {
          this.tableData.releaseList = [];
          this.$notify({
            message: error || "获取失败",
            type: "error",
          });
        }
      },
      // 查看发布环境占用情况
      async checkEnvReleaseOccupation() {
        await this.queryDeployCenterList()
        console.log('this.deploy_info', this.deploy_info);
        let flag = false;
        this.deploy_info.some(itm => {
          const name = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
          const { module = '', env = '', domain = '' } = this.form;
          if ((itm.moduleEnv === `${module}-${env}.${domain}`) && itm.name !== name) {
            if (!itm.holeUpTime) return;
            const compareTime = Date.parse(itm.holeUpTime) > Date.now()
            if (compareTime) {// true提醒 false不提醒
              this.current_deploy_info = {
                env: env,
                time: itm.holeUpTime,
                name: itm.name
              }
              flag = true;
            }
          }
        })
  
        if (flag) {
          this.dialog.releaseTipVisible = true;
        } else {
          this.queryUatEnvRelease()
        }
      },
      // uat发布
      async queryUatEnvRelease() {
        this.$refs["form"].validate(async (valid) => {
          if (valid) {
            this.dialog.releaseTipVisible = false;
            this.loading.uatEnvRelease = true;
            this.dialog.releaseResultVisible = true;
            this.queryPreEnvRelease()
          }
        })
  
      },
      // 实时日志
      async queryActionNowLogInfo(type) {
        const {
          id: task_id = "",
          demandId = '',
        } = this.form;
        this.dialog.releaseResultLogVisible = true;
        const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
        this.openWebSocket({
          url: '/ws/devops',
          params: { pid: 0, task_id:0, stage_id: 0, username },
          title: '实时日志'
        })
      },
      // 预发环境代码发布
      async queryPreEnvRelease() {
        const cacheDate = new Date();
        const {
          module = "",
          due_time = "",
          branch = "",
          commit = "",
          env = "",
          domain = "",
          id = "",
          demandId = "",
          devloper = ''
        } = this.form;
        try {
          const param = {
            // pid: demandId,
            action: "run",
            // stage_id: 9,
            // task_id: id,
            // stage_name: "tester_stagCodeDeploy",
            domain,
            module,
            due_time,
            branch,
            commit,
            env,
            // user_rd: devloper.nameEn ? devloper.nameEn: "",
          };
          const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
          this.openWebSocket({ url: '/ws/devops', params: { pid:0, task_id: 0, stage_id: 0, username }, title: '预发环境代码发布中' })
          const ret = await postDevopsSpaceStageActionNewApi(param);
          const output = ret?.deploy_output?.deploy || {};
          if (typeof output === 'string') {
            this.$notify({
              message: output || "数据错误",
              type: "error",
            });
          }
          const isSuccess = typeof output === 'string' ? true : ret.deploy_output?.deploy[0]?.code === 0;
          this.timeOutSetProgressBar(`发布${isSuccess ? "成功" : "失败"}，用时：${formatDate(this, this.$moment(new Date()).diff(cacheDate))}`, `${isSuccess ? "success" : "exception"}`)
        } catch (error) {
          this.timeOutSetProgressBar('发布失败')
        } finally {
          this.loading.uatEnvRelease = false;
        }
      },
      // 延迟设置进度条
      timeOutSetProgressBar(completeInfo, status = 'exception') {
        const initProgressBar = {
          percentage: 100,
          title: this.form.module || '',
          customColor: "",
        }
        setTimeout(() => {
          this.setProgressBar({
            ...initProgressBar,
            completeInfo,
            status,
          });
        }, 500)
      },
      // uat环境sql执行
      async queryUatEnvSqlDone() {
        this.loading.uatEnvSqlDone = true;
        this.dialog.sqlDoneVisible = true;
        const cacheDate = new Date();
        const {
          module = "",
          ref = "",
          deploy_filepath = "",
          env = "",
          id = "",
          demandId = "",
          sqlcontent = "",
          devloper = '',
        } = this.form;
  
        let param = {
          action: "run",
          stage_id: 0,
          task_id: 0,
          stage_name: 0,
          module_type: 0,
          env,
          sqlcontent:0,
          pid: 0,
          user_rd: 0,
        };
        if (module === "odoo") {
          param.ref = ref;
          param.deploy_filepath = deploy_filepath;
        }
        const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
        this.openWebSocket({ url: '/ws/devops', params: { pid: 0, task_id: 0, stage_id: 0, username }, title: '测试环境sql部署中' })
        try {
          const ret = await postDevopsSpaceStageActionNewApi(param);
          const output = ret?.deploy_output?.deploy || {};
          const isSuccess = this.isSqlSuccess(output);
          this.timeOutSetProgressBar(`SQL执行${isSuccess ? "成功" : "失败"}，用时：${formatDate(this, this.$moment(new Date()).diff(cacheDate))}`, `${isSuccess ? "success" : "exception"}`)
          if (typeof output === 'string') {
            this.$notify({
              message: output || "数据错误",
              type: "error",
            });
          }
        } catch (error) {
          this.dialog.sqlDoneVisible = false;
          this.$notify({
            message: error || "数据错误",
            type: "error",
          });
        } finally {
          this.loading.uatEnvSqlDone = false;
        }
      },
      // 获取sql执行记录
      async queryUatEnvSqlDoneLog() {
        try {
          const { id, demandId } = this.form;
          const ret = await getDevOpsSpaceListStageOutputApi({
            stage_id: 0,
            task_id: 0,
            pid: 0,
          });
          if (ret.status === "success") {
            let instance = JSON.parse(ret.data) || [];
            instance.map((item) => {
              return (item.content = JSON.stringify(item.output, null, 2));
            });
            this.tableData.sqlList = instance.map((item) => {
              return {
                state: this.isSqlSuccess(item?.output) ? 0 : 1,
                content: item.content,
                logtime: item.logtime,
                deploy_filepath: item?.output?.msg?.parms?.deploy_filepath || "",
                sqlcontent: item?.output?.msg?.parms?.sqlcontent || "",
                module_type: item?.output?.msg?.parms?.module_type || "",
              };
            });
            this.dialog.sqlLogVisible = true;
          }
        } catch (error) {
          this.tableData.sqlList = [];
          this.$notify({
            message: error || "获取失败",
            type: "error",
          });
        }
      },
      // Sql质量检测
      async querySqlQualityTest() {
        try {
          this.loading.sqlQualityTest = true;
          const param = {
            action: '',
            task_id: 0,
            content: 0
          }
          const ret = await postDevopsSpaceStageActionNewApi(param);
          if (ret.status === 'success') {
            this.sqlQualityTestInfo = ret.data;
            this.dialog.sqlQualityTest = true;
          }
        } catch (error) {
  
        } finally {
          this.loading.sqlQualityTest = false;
        }
      },
      //设置sql语句
      changeTextarea(val, type) {
        this.$set(this.form, type, val);
      },
      // 编辑额外部署sql文件
      async handleSqlDialogVisible(type) {
        const { id, demandId } = this.form;
        let ret = {};
        try {
          switch (type) {
            case "info":
              this.dialog.sqleditor = false;
              ret = await getEdiApi({ id, pid:demandId });
              this.showGitDeploy ? this.form.deploy_filepath = ret.data : this.form.sqlcontent = ret.data;
              break;
            case "edit":
              ret = await getEdiApi({ id, pid:demandId });
              this.form.sqlExtracontent = ret.data || "";
              this.sqlQualityTestInfo = {};
              break;
            case "save":
              ret = await postUpdateEdiApi({
                id,
                content: this.form.sqlExtracontent,
                pid: demandId,
              });
              break;
            default:
              break;
          }
          if (ret.status === "success") {
            if (type === "info") return;
            this.dialog.sqlVisible = type === "edit" ? true : false;
          } else {
            if (type === 'save') {
              this.sqlQualityTestInfo = ret.data.data;
              this.dialog.sqlVisible = true;
              this.$notify({
                message: "保存失败",
                type: "error",
              });
              return;
            };
            this.$notify({
              message: "数据错误",
              type: "error",
            });
          }
        } catch (error) {
          this.$notify({
            message: error || "数据错误",
            type: "error",
          });
        } finally {
          this.dialog.sqleditor = true;
        }
      },
      // 获取环境占用列表
      async queryDeployCenterList() {
        try {
          this.loading.envFootprint = true;
          const { module = "", demandId = "", domain = '' } = this.form;
  
          const ret = await postDeployCenterApi({
            action: "add",
            services: module ? [module] : [],
            pid: 0,
            domain
          });
          let deploy_info = [];
          ret[module]?.deploy_info?.forEach((item) => {
            item?.records.forEach((itm) => {
              deploy_info.push({
                moduleEnv: itm[2],
                name: itm[0],
                branch: itm[4],
                rorrelation_url:
                  item.config_url_prefix + itm[2] + item.config_url_postfix,
                release_url: itm[1],
                holeUpTime: itm[6],
                commit: itm[3],
                startDate: itm[5],
                platform: item.platform,
                record_id: itm[8] || ''
              });
            });
          });
          deploy_info.sort(function (a, b) {
            return new Date(a.holeUpTime) - new Date(b.holeUpTime);
          });
          this.deploy_info = deploy_info;
        } catch (error) {
        } finally {
          this.loading.envFootprint = false;
        }
      },
      // 解除环境占用
      async handleReleaseOccupy(index, row) {
        try {
          const param = {
            action: "deploy_update_duetime",
            record_id: row.record_id
          }
          const ret = await postDeployRecordingApi(param)
          this.$notify({
            message: ret.msg,
            type: ret.status === 'success' ? "success" : "error",
          })
          this.queryDeployCenterList()
        } catch (error) {
          this.$notify({
            message: "数据错误",
            type: "error",
          })
        }
      },
      // 发布类型判断
      releaseType(time) {
        if (!time) return { type: "success", color: '#67C23A' };
        let t = this.$moment().diff(time, "hour");
        if (t <= -24) {
          return { type: "danger", color: '#F56C6C' };
        } else if (t >= 0) {
          return { type: "success", color: '#67C23A' };
        } else {
          return { type: "warning", color: '#E6A23C' };
        }
      },
      // 环境占用发布
      handleRelease(index, row) {
        window.open(row.release_url);
      },
      // 关联配置
      async handleRorrelation(index, row) {
        try {
          const ret = await getAutoCustomerApi(row.rorrelation_url);
          this.msg.rorrelationContentMsg = ret || "";
          if (ret) {
            this.dialog.rorrelationVisible = true;
          }
        } catch (error) {
          this.msg.rorrelationContentMsg = "";
          this.dialog.rorrelationVisible = false;
        }
      },
      // UAT环境sql 执行成功失败判断
      isSqlSuccess(output = {}) {
        if (typeof output === 'string') return false
        let flag = true;
        ["sql", "script", "conf"].forEach((i) => {
          if (output[i].length && output[i][0].code !== 0) {
            flag = false;
          }
        });
        return flag && output?.msg?.code === 0;
      },
      // 获取sql执行记录
      async queryPreEnvSqlDoneLog() {
        try {
          const { id, demandId = ''  } = this.form;
          const ret = await getDevOpsSpaceListStageOutputApi({
            stage_id: 0,
            task_id: 0,
            pid: 0,
          });
          if (ret.status === "success") {
            let instance = JSON.parse(ret.data) || [];
            instance.map((item) => {
              return (item.content = JSON.stringify(item.output, null, 2));
            });
            this.tableData.sqlList = instance.map((item) => {
              return {
                state: this.isSqlSuccess(item?.output) ? 0 : 1,
                content: item.content,
                logtime: item.logtime,
                deploy_filepath: item?.output?.msg?.parms?.deploy_filepath || "",
                sqlcontent: item?.output?.msg?.parms?.sqlcontent || "",
                module_type: item?.output?.msg?.parms?.module_type || "",
              };
            });
            this.dialog.sqlLogVisible = true;
          }
        } catch (error) {
          this.tableData.sqlList = [];
          this.$notify({
            message: error || "获取失败",
            type: "error",
          });
        }
      },
      // UAT完成
      async submit(action) {
        if (action !== 'run') {
          this.submitApi(action)
          return;
        }
        this.$refs["form"].validate(async (valid) => {
          if (valid) {
            this.submitApi(action)
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      async submitApi(action) {
        this.$set(this.loading, action === 'run' ? 'uatTestinged' : action, true)
        const {
          id = "",
          demandId = '',
          uat_content = "",
          uat_status = '',
          devloper = '',
          pm = '',
          tester = "",
          user_uat = "",
          branch = '',
          module = "",
          env = "",
        } = this.form;
  
        const param = {
          action,
          uat_content:0,
          uat_status:0,
          stage_id: 0,
          stage_name: 0,
          task_id: 0,
          pid: 0,
          branch,
          user_rd: "",
          user_pm: '',
          user_qa:  '',
          user_uat: '',
          module,
          env,
        };
        try {
          const ret = await postDevopsSpaceStageActionNewApi(param);
          let info = '';
          let output = ret?.deploy_output?.deploy;
          let success = false;
          if (action === 'run' && typeof output != 'string') {
            info = output?.uat[0].msg;
            success = output?.uat[0].code === 0;
          }
          if (action === 'skip' && typeof output != 'string') {
            info = success = output?.msg;
          }
          if (action === 'gobackdev' && typeof output != 'string') {
            info = output?.msg
            success = output?.code === 0;
          }
          this.$notify({
            message: typeof output == 'string' ? ret?.deploy_output : info,
            type: success ? "success" : "error",
          });
          if (success) {
            setTimeout(() => {
              const nextStep = action === 'gobackdev' ? 'developing' : 'toRelease';
              this.handleClose(nextStep)
              //this.handleClose()
            }, 3000)
          }
        } catch (error) {
          this.$notify({
            message: error || "操作失败",
            type: "error",
          });
        } finally {
          this.loading.uatTestinged = false;
          this.loading.skip = false;
          this.loading.gobackdev = false;
        }
      },
      // 富文本事件
      changeContent(val) {
        this.form.uat_content = val;
      }
    },
  };
  </script>
  <style lang="scss">
  .uatTesting_model_dialog {
    .el-dialog__body {
      padding-bottom: 0;
    }
  }
  
  .uatTesting_model_dialog_child {
    .el-dialog__body {
      padding: 0 20px 10px;
    }
  }
  </style>
  